import { render } from "./TheSideMenu.vue?vue&type=template&id=426bd8fa&ts=true"
import script from "./TheSideMenu.vue?vue&type=script&lang=ts"
export * from "./TheSideMenu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__